import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { DeviceInformation } from '@shared-ui/viewport-context';

import { PackageType } from 'src/common/models/multi-item/multi-item-types';
import { PinnedHotelViewModel, PropertyListingBadgeModel, ShortlistModel } from 'models';

import { UitkCardMedia } from 'uitk-react-cards';
import { UitkFigureAspectRatioType } from 'uitk-react-images';

import { ListingGalleryProps } from 'components/search/listing/internals/listing-gallery';
import { PropertyFields } from 'src/common/__generated__/api';
import { TitleGallery } from './title-gallery';

export interface TitleProps {
  deviceInformation: DeviceInformation;
  displayViewed: boolean;
  fallbackImageUrl: string;
  imageUrl: string;
  lazyLoadImg: boolean;
  listingClickHandler: (property: PropertyFields.Fragment) => void;
  mapListingView?: boolean;
  name: string;
  navigateOnClient: (relativePath: string) => void;
  onFavoriteClick?: () => void;
  packageType: PackageType;
  pinned?: PinnedHotelViewModel;
  propertyListingBadgeModel: PropertyListingBadgeModel;
  ratio: UitkFigureAspectRatioType; // exp27314 - pwa_mobile_PhotosHeight
  referralObject: Record<string, unknown>;
  shortlistModel: ShortlistModel;
  travelAd: { impressionTrackingUrl: string };
}

export type LocalizedTitleProps = LocalizedComponentProps & TitleProps;

@withLocalization
export class Title extends React.Component<LocalizedTitleProps> {
  constructor(props) {
    super(props);

    this.queuedImageFallbackcb = this.queuedImageFallbackcb.bind(this);
  }

  public render() {
    const {
      deviceInformation,
      displayViewed,
      fallbackImageUrl,
      imageUrl,
      l10n,
      lazyLoadImg,
      listingClickHandler,
      mapListingView,
      name,
      navigateOnClient,
      onFavoriteClick,
      packageType,
      pinned,
      propertyListingBadgeModel,
      ratio,
      referralObject,
      shortlistModel,
      travelAd,
    } = this.props;

    const favButtonText = {
      labelSave: l10n.formatText('hotels.searchResults.shortlist.saveToList.a11yLabel', this.props.name),
      labelRemove: l10n.formatText('hotels.searchResults.shortlist.removeFromList.a11yLabel', this.props.name),
      onSaveMessage: l10n.formatText('hotels.shortlist.saveToList.notification', this.props.name),
    };

    const renderGal: ListingGalleryProps = {
      deviceInformation,
      listingClickHandler,
      mapListingView,
      navigateOnClient,
      onFavoriteClick,
      packageType,
      ratio,
    };

    const renderImg: RenderImageProps = {
      fallbackImageSrc: fallbackImageUrl,
      name,
      propertyListingBadgeModel,
      travelAd,
      ratio,
      displayViewed,
      referralObject,
      shortlistModel,
      favButtonText,
      imageUrl,
      queuedImageFallbackcb: this.queuedImageFallbackcb,
    };

    const renderlistingGalleryProps: RenderGalleryProps = {
      listingGalleryProps: renderGal,
      renderImageProps: renderImg,
      lazyLoadImg,
    };

    const pinnedClasses = pinned?.heading ? 'uitk-flat-border-bottom uitk-flat-border-top' : '';
    const borderBottomFlatClass = pinnedClasses === '' ? 'uitk-flat-border-bottom' : '';

    return (
      <Viewport>
        <ViewSmall>
          <UitkCardMedia className={`${pinnedClasses} ${borderBottomFlatClass}`}>
            <TitleGallery {...renderlistingGalleryProps} />
          </UitkCardMedia>
        </ViewSmall>
        <ViewMedium>
          <UitkCardMedia className={`${pinnedClasses}`}>
            <TitleGallery {...renderlistingGalleryProps} />
          </UitkCardMedia>
        </ViewMedium>
      </Viewport>
    );
  }

  private queuedImageFallbackcb(img, queuedImage): void {
    if (img && img.length > 0) {
      queuedImage.setState({ src: img });
    }
  }
}

export interface RenderImageProps {
  propertyListingBadgeModel: PropertyListingBadgeModel;
  fallbackImageSrc: string;
  name: string;
  travelAd: {
    impressionTrackingUrl: string;
  };
  ratio: UitkFigureAspectRatioType;
  displayViewed: boolean;
  referralObject: Record<string, unknown>;
  shortlistModel: ShortlistModel;
  favButtonText: {
    labelSave: string;
    labelRemove: string;
    onSaveMessage: string;
  };
  imageUrl: string;
  queuedImageFallbackcb: (img: any, queuedImage: any) => void;
}

export interface RenderGalleryProps {
  listingGalleryProps: ListingGalleryProps;
  renderImageProps: RenderImageProps;
  lazyLoadImg: boolean;
}
